<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg4 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="event"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="event"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <!-- <v-flex lg6 md12 sm12 xs12>
                    <highcharts :options="chartGMVOptions"></highcharts>
                </v-flex> -->
                <v-flex lg12 md12 sm12 xs12>
                    <highcharts :options="chartOptions"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-flex lg12>
            <v-card class="mb-8">
                <v-data-table fixed-header height= "70vh" hide-default-footer :sortable="false" :items="items" :server-items-length="items ? items.length : 0" :loading="loading" :mobile-breakpoint="100" hide-default-header>
                    <template v-slot:header>
                        <thead>
                            <tr>
                                <th rowspan="2" class="text-center">Tháng</th>
                                <th rowspan="2" class="text-end">Tổng giao dịch</th>
                                <th colspan="6" class="text-center">ĐH Mua hộ</th>
                                <th colspan="3" class="text-center">ĐH Ký gửi</th>
                                <th colspan="3" class="text-center">TT Hộ</th>
                                <!-- <th rowspan="2" class="text-end">Tổng DT</th> -->
                                <th rowspan="2" class="text-end">Tổng Lợi nhuận</th>
                            </tr>
                            <tr>
                                <!-- ĐH Mua hộ -->
                                <th class="text-end">Giao dịch</th>
                                <th class="text-end">Phí VC</th>
                                <th class="text-end">Lợi nhuận VC</th>
                                <th class="text-end">Phí mua</th>
                                <th class="text-end">Chênh tỷ giá</th>
                                <th class="text-end">Lợi nhuận đặt hàng</th>
                                <!-- ĐH Ký gửi -->
                                <th class="text-end">Giao dịch</th>
                                <th class="text-end">Phí VC</th>
                                <th class="text-end">Lợi nhuận VC</th>
                                <!-- TT Hộ -->
                                <th class="text-end">Giao dịch</th>
                                <th class="text-end">Chênh tỷ giá</th>
                                <th class="text-end">Phí DV</th>
                            </tr>
                        </thead>
                    </template>
                    <template v-slot:item="{ item }">
                        <tr>
                            <td class="text-center">{{item.TransactionMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")}}</td>
                            <td class="text-end">{{ item.TotalTransaction | currency}}</td>
                            <!-- Đơn mua hộ -->
                            <td class="text-end">{{ item.OrderTransaction | currency}}</td>
                            <td class="text-end">{{ item.OrderFeeWeight | currency}}</td>
                            <td class="text-end">{{ item.OrderProfitWeight | currency}}</td>
                            <td class="text-end">{{ item.OrderFeeBuy | currency}}</td>
                            <td class="text-end">{{ item.OrderDiffExchange | currency}}</td>
                            <td class="text-end">{{ item.OrderBargain | currency}}</td>
                            <!-- Đơn ký gửi -->
                            <td class="text-end">{{ item.DepositTransaction | currency}}</td>
                            <td class="text-end">{{ item.DepositFeeWeight | currency}}</td>
                            <td class="text-end">{{ item.DepositProfitWeight | currency}}</td>
                            <!-- Thanh toán hộ -->
                            <td class="text-end">{{ item.PayServiceTransaction | currency}}</td>
                            <td class="text-end">{{ item.PayServiceRevenue | currency}}</td>
                            <td class="text-end">{{ item.PayServiceFee | currency}}</td>
                            <!-- Tổng doanh thu -->
                            <!-- <td class="text-end">{{ item.TotalFeeWeight + item.TotalFeeBuy + item.TotalDiffExchange + item.TotalBargain | currency}}</td> -->
                            <!-- Tổng lợi nhuận -->
                            <td class="text-end">{{ (item.TotalProfitWeight + item.TotalFeeBuy + item.TotalDiffExchange + item.TotalBargain + item.PayServiceRevenue + item.PayServiceFee) | currency}}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="grey lighten-3">
                            <td class="font-weight-bold text-center">TỔNG</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalTransaction | currency }}</td>
                            <!-- Đơn mua hộ -->
                            <td class="font-weight-bold text-end">{{ summary.OrderTransaction | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.OrderFeeWeight | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.OrderProfitWeight | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.OrderFeeBuy | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.OrderDiffExchange | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.OrderBargain | currency }}</td>
                            <!-- Đơn ký gửi -->
                            <td class="font-weight-bold text-end">{{ summary.DepositTransaction | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.DepositFeeWeight | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.DepositProfitWeight | currency }}</td>
                            <!-- Thanh toán hộ -->
                            <td class="font-weight-bold text-end">{{ summary.PayServiceTransaction | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.PayServiceRevenue | currency }}</td>
                            <td class="font-weight-bold text-end">{{ summary.PayServiceFee | currency }}</td>
                            <!-- Tổng doanh thu -->
                            <!-- <td class="font-weight-bold text-end">{{ summary.TotalRevenue | currency }}</td> -->
                            <!-- Tổng lợi nhuận -->
                            <td class="font-weight-bold text-end">{{ summary.TotalProfit | currency }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import {Chart} from 'highcharts-vue';
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        highcharts: Chart 
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            viewName: "bao-cao-tong-hop",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.generalReport.data,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        summary() {
            var ret = {
                'TotalTransaction': _.sumBy(this.items, 'TotalTransaction'),
                'TotalFeeWeight': _.sumBy(this.items, 'TotalFeeWeight'),
                'TotalProfitWeight': _.sumBy(this.items, 'TotalProfitWeight'),
                'TotalFeeBuy': _.sumBy(this.items, 'TotalFeeBuy'),
                'TotalDiffExchange': _.sumBy(this.items, 'TotalDiffExchange'),
                'TotalBargain': _.sumBy(this.items, 'TotalBargain'),
                // Đơn mua hộ
                'OrderTransaction': _.sumBy(this.items, 'OrderTransaction'),
                'OrderFeeWeight': _.sumBy(this.items, 'OrderFeeWeight'),
                'OrderProfitWeight': _.sumBy(this.items, 'OrderProfitWeight'),
                'OrderFeeBuy': _.sumBy(this.items, 'OrderFeeBuy'),
                'OrderDiffExchange': _.sumBy(this.items, 'OrderDiffExchange'),
                'OrderBargain': _.sumBy(this.items, 'OrderBargain'),
                // Đơn ký gửi
                'DepositTransaction': _.sumBy(this.items, 'DepositTransaction'),
                'DepositFeeWeight': _.sumBy(this.items, 'DepositFeeWeight'),
                'DepositProfitWeight': _.sumBy(this.items, 'DepositProfitWeight'),
                // Thanh toán hộ
                'PayServiceTransaction': _.sumBy(this.items, 'PayServiceTransaction'),
                'PayServiceRevenue': _.sumBy(this.items, 'PayServiceRevenue'),
                'PayServiceFee': _.sumBy(this.items, 'PayServiceFee'),
                'TotalRevenue': 0,
                'TotalProfit': 0
            };
            ret.TotalRevenue = ret.TotalFeeWeight + ret.TotalFeeBuy + ret.TotalDiffExchange + ret.TotalBargain;
            ret.TotalProfit = ret.TotalProfitWeight + ret.TotalFeeBuy + ret.TotalDiffExchange + ret.TotalBargain + ret.PayServiceRevenue + ret.PayServiceFee;
            return ret;
        },
        chartOptions() {
            var dataChart =  _.sortBy(this.items,'TransactionMonth');
            var ret = {
                chart: { type: 'line' },
                title: { text: 'Doanh thu theo loại đơn' },
                credits: { enabled: false },
                tooltip: {shared: true},
                xAxis: {
                    categories: _.map(dataChart, function(x) {return x.TransactionMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")})
                },
                yAxis: {
                    title: {
                        text: 'Tổng tiền (VNĐ)'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: false
                        }
                    }
                },
                series: [
                    { 
                        name: 'ĐH Mua hộ - Phí VC',
                        data: _.map(dataChart, 'OrderFeeWeight'),
                        color: '#42A5F5'
                    },
                    { 
                        name: 'ĐH Mua hộ - Phí mua',
                        data: _.map(dataChart, 'OrderFeeBuy'),
                        color: '#66BB6A'
                    },
                    { 
                        name: 'ĐH Mua hộ - Chênh TG',
                        data: _.map(dataChart, 'OrderDiffExchange'),
                        color: '#FFA726'
                    },
                    { 
                        name: 'ĐH Mua hộ - Lợi nhuận',
                        data: _.map(dataChart, 'OrderBargain'),
                        color: '#AB47BC'
                    },
                    { 
                        name: 'ĐH Ký gửi',
                        data: _.map(dataChart, 'DepositFeeWeight'),
                        color: '#26C6DA'
                    },
                    { 
                        name: 'TT Hộ',
                        data: _.map(dataChart, 'PayServiceFee'),
                        color: '#EC407A'
                    },
                    { 
                        name: 'Tổng doanh thu',
                        data: _.map(dataChart, function(x) {return x.TotalFeeWeight + x.TotalFeeBuy + x.TotalDiffExchange + x.TotalBargain}),
                        color: '#EF5350',
                        lineWidth: 3,
                        marker: { radius: 5 }
                    }
                ]
            };

            return ret;
        },
        chartGMVOptions() {
            var dataChart =  _.sortBy(this.items,'TransactionMonth');
            var ret = {
                chart: { type: 'line' },
                title: { text: 'Tổng giao dịch' },
                credits: { enabled: false },
                tooltip: {},
                xAxis: {
                    categories: _.map(dataChart, function(x) {return x.TransactionMonth.toString().replace(/(\d{4})(\d{2})/, "$2-$1")})
                },
                yAxis: {
                    title: {
                        text: 'Tổng tiền (VNĐ)'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [
                    { 
                        name: 'Tổng giao dịch',
                        data: _.map(dataChart, 'TotalTransaction')
                    }
                ]
            };

            return ret;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
            this.$store.dispatch("report/getGeneralReport", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.v-data-table >>> thead th {
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
    padding: 8px 16px !important;
    font-weight: bold !important;
    background-color: #f5f5f5 !important;
}
</style>